export const ATTRIBUTE_LABEL = "Label";
export const ATTRIBUTE_BRAND = "Brand";
export const ATTRIBUTE_ARTIST = "Artist";
export const ATTRIBUTE_COLOR = "Color";
export const ATTRIBUTE_DESIGNER = "Designer";
export const ATTRIBUTE_MATERIAL = "Material";
export const ATTRIBUTE_STYLE = "Style";
export const ATTRIBUTE_ADDITIONAL_INFO = "AdditionalInfo";
export const ATTRIBUTE_FIRST_OWNER = "first-owner";
export const ATTRIBUTE_SUBJECT = "Subject";
export const ATTRIBUTE_USAGE = "UsageSign";

export const ADDITIONAL_ATTRIBUTE_QUALITY = "quality";
export const ADDITIONAL_ATTRIBUTE_NUMBER_OF_ITEMS = "number_of_items";
export const ADDITIONAL_ATTRIBUTE_HEIGHT = "height";
export const ADDITIONAL_ATTRIBUTE_WIDTH = "width";
export const ADDITIONAL_ATTRIBUTE_DEPTH = "depth";
export const ADDITIONAL_ATTRIBUTE_SEAT_HEIGHT = "seat_height";
export const ADDITIONAL_ATTRIBUTE_ART_ORIENTATION = "art_orientation";
export const ADDITIONAL_ATTRIBUTE_ART_SIZE = "art_size";

export type PdpProductAttributes = {
  [ATTRIBUTE_LABEL]?: string[];
  [ADDITIONAL_ATTRIBUTE_ART_ORIENTATION]?: string[];
  [ADDITIONAL_ATTRIBUTE_ART_SIZE]?: string[];
  [ATTRIBUTE_COLOR]?: { slug: string; hex: string }[];
  [ADDITIONAL_ATTRIBUTE_DEPTH]?: string[];
  [ATTRIBUTE_FIRST_OWNER]?: boolean[];
  hasAttributes?: boolean;
  [ADDITIONAL_ATTRIBUTE_HEIGHT]?: string[];
  [ADDITIONAL_ATTRIBUTE_NUMBER_OF_ITEMS]?: string[];
  [ATTRIBUTE_MATERIAL]?: string[];
  [ATTRIBUTE_STYLE]?: string[];
  [ATTRIBUTE_USAGE]?: string[];
  [ADDITIONAL_ATTRIBUTE_SEAT_HEIGHT]?: string[];
  [ATTRIBUTE_SUBJECT]?: string[];
  [ATTRIBUTE_BRAND]?: string[];
  [ATTRIBUTE_DESIGNER]?: string[];
  [ADDITIONAL_ATTRIBUTE_WIDTH]?: string[];
  [ADDITIONAL_ATTRIBUTE_QUALITY]?: string[];
  [ATTRIBUTE_ARTIST]?: string[];
};
